import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'

// local components
import MasterCategories from './MasterCategories'
import MasterProducts from './MasterProducts'

export default class MasterCatalogPage extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isMfeLoadingFailed: false,
    }
  }

  setIsMfeLoadingFailed = (isMfeLoadingFailed) => this.setState({ isMfeLoadingFailed })

  render() {
    const { match } = this.props

    return (
      <Fragment>
        <Route exact path={`${match.url}/categories`} component={MasterCategories} />
        <Route
          exact
          path={`${match.url}/products`}
          render={(props) => <MasterProducts {...props} />}
        />
        {/* <Route exact path={`${match.url}/uniqueAttributes`} component={UniqueAttributes} /> */}
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/MasterCatalog/MasterCatalogPage.js